import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionUnitTable extends Layout {
    sourceMCFilterJunctionUnit: DataSource;
    tableMCFilterJunctionUnit: Table;
}
